import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const appendIfValid = (formData, key, value) => {
  if (value !== null && value !== undefined) {
    formData.append(key, value);
  }
};

const create_product = async (product) => {
  try {
    let data = new FormData();
    data.append("image", product?.image[0]);
    data.append("name", product?.name);
    data.append("barcode", product?.barcode);
    data.append("unit", product?.unit);
    data.append("category", product?.category);
    data.append("brand", product?.brand);
    data.append("stock", product?.stock);
    data.append("expiry", product?.expiry);
    data.append("sale_price", product?.sale_price);
    data.append("purchase_price", product?.purchase_price);
    data.append("wholesale_price", product?.wholesale_price);
    appendIfValid(data, "tax", product?.tax);
    data.append("type", product?.type);
    data.append("status", product?.status);
    data.append("details", JSON?.stringify(product?.details));

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-product`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const create_bulk_product = async (product) => {
  try {
    let data = {
      details: product?.details,
      branch: product?.branch,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/create-bulk-product`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const update_product = async (product) => {
  try {
    let data = new FormData();
    data.append("id", product?.id);
    data.append("image", product?.image[0]);
    data.append("name", product?.name);
    data.append("barcode", product?.barcode);
    data.append("unit", product?.unit);
    data.append("category", product?.category);
    data.append("brand", product?.brand);
    data.append("stock", product?.stock);
    data.append("expiry", product?.expiry);
    data.append("sale_price", product?.sale_price);
    data.append("purchase_price", product?.purchase_price);
    data.append("wholesale_price", product?.wholesale_price);
    appendIfValid(data, "tax", product?.tax);
    data.append("type", product?.type);
    data.append("status", product?.status);
    data.append("details", JSON?.stringify(product?.details));

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/update-product`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_product = async (product) => {
  try {
    const data = {
      id: product?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-product`, data, config);
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_product_name = async (product) => {
  try {
    const data = {
      name: product?.name,
      branch: product?.branch,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-product-name`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_products = async (product) => {
  try {
    const data = {
      search: product?.search,
      sort: product?.sort,
      unit: product?.unit,
      category: product?.category,
      brand: product?.brand,
      type: product?.type,
      status: product?.status,
      page: product?.page,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-products`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_products_reports = async (product) => {
  try {
    const data = {
      search: product?.search,
      sort: product?.sort,
      unit: product?.unit,
      category: product?.category,
      brand: product?.brand,
      type: product?.type,
      status: product?.status,
      page: product?.page,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-products-reports`,
      data,
      config
    );

    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_product_unit_detail = async (product) => {
  try {
    const data = {
      id: product?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-product-unit-detail`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_product_barcode = async (product) => {
  try {
    const data = {
      barcode: product?.barcode,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-product-barcode`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_unavailable_products = async (product) => {
  try {
    const data = {
      branch: product?.branch,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-unavailable-products`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const create_products_csv = async (inventory) => {
  try {
    let data = new FormData();
    data.append("file", inventory?.file);

    const token = localStorage.getItem("user");

    const response = await axios.post(`${APIURL}/create-products-csv`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response?.data;
  } catch (error) {
    return error;
  }
};


const get_all_products_without_category = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-products-without-category`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching products without category:", error);
    return {
      status: false,
      message: error.response?.data?.message || "Failed to fetch products"
    };
  }
};

const assign_category_to_products = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/assign-category-to-products`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    console.error("Error assigning category to products:", error);
    return {
      status: false,
      message: error.response?.data?.message || "Failed to assign category"
    };
  }
};

const get_all_products_without_brand = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-products-without-brand`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching products without brand:", error);
    return {
      status: false,
      message: error.response?.data?.message || "Failed to fetch products"
    };
  }
};

const assign_brand_to_products = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/assign-brand-to-products`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    console.error("Error assigning brand to products:", error);
    return {
      status: false,
      message: error.response?.data?.message || "Failed to assign brand"
    };
  }
};


const get_all_products_without_unit_details = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-products-without-unit-details`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching products without unit details:", error);
    return {
      status: false,
      message: error.response?.data?.message || "Failed to fetch products"
    };
  }
};

const get_products_with_multiple_units = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-products-with-multiple-units`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching products with multiple units:", error);
    return {
      status: false,
      message: error.response?.data?.message || "Failed to fetch products"
    };
  }
};

const assign_unit_to_products = async (data) => {
  try {
    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/assign-unit-to-products`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    console.error("Error assigning unit to products:", error);
    return {
      status: false,
      message: error.response?.data?.message || "Failed to assign unit"
    };
  }
};

export {
  create_product,
  create_bulk_product,
  update_product,
  get_product,
  get_product_name,
  get_all_products,
  get_all_products_reports,
  get_product_unit_detail,
  get_product_barcode,
  get_all_unavailable_products,
  create_products_csv,
  get_all_products_without_category,
  assign_category_to_products,
  get_all_products_without_brand,
  assign_brand_to_products,
  get_all_products_without_unit_details,
  get_products_with_multiple_units,
  assign_unit_to_products
};
